export enum SupportActivityResult {
    COMPLETED = 'completed',
    CANCELED = 'canceled',
}
